import React, { useState, useEffect } from "react";
import { API_URL } from "../../constant";
import { useNavigate } from 'react-router-dom';
import '../MiniAgentReferralHistoty/MiniAgentReferralHistory.css';

const DistributionHistory = () => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const navigate = useNavigate();

  const fetchHistory = async (searchQuery = "", page = 1) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("account_admin_token");
      const url = new URL(`${API_URL}/api/account-admin/distributions`);
      url.searchParams.append("page", page);
      url.searchParams.append("per_page", "10");
      if (searchQuery) {
        url.searchParams.append("search", searchQuery);
      }
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (response.ok) {
        const data = await response.json();
        setHistory(data.distributions?.data || []);
        setTotalPages(data.distributions?.last_page || 1);
      }
    } catch (err) {
      console.error("Failed to load distribution history");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory(search, currentPage);
  }, [currentPage]);

  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchHistory(search, 1);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div
      style={{
       
      }}
      className="customer-referral-history-container"
    >
      {/* <h2 style={{ color: "#333", marginBottom: "20px", fontSize: "2rem", fontWeight: "bold" }}>
        Sales Blockchain Ledger (Distribution History)
      </h2> */}

      <div style={{ background: "transparent", borderRadius: "12px", marginBottom: "20px", boxShadow: "0 4px 15px rgba(0,0,0,0.1)" }}>
        <form onSubmit={handleSearch} style={{ display: "flex", gap: "10px" }}>
          <input
            type="text"
            placeholder="Search by Customer Name or Email..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ flex: 1, padding: "10px", borderRadius: "8px", border: "1px solid #ccc" }}
          />
          <button type="submit" style={{ padding: "10px 20px", background: "#001964", color: "#fff", border: "none", borderRadius: "8px", cursor: "pointer" }}>
            Search
          </button>
        </form>
      </div>

      <div style={{ background: "#fff", borderRadius: "12px", overflow: "hidden", boxShadow: "0 4px 15px rgba(0,0,0,0.1)", padding: "8px" }}>
        {loading ? (
          <div className="loading-container" style={{ margin: "40px auto" }}>
              <div className="loading-spinner" style={{ borderColor: "#001964 transparent #001964 transparent" }}></div>
              <p style={{ marginTop: '10px', color: "#333" }}>Loading history...</p>
          </div>
        ) : history.length === 0 ? (
          <div className="empty-state" style={{ margin: "40px auto", color: "#333" }}>
            <div className="empty-icon">📊</div>
            <h3 style={{ color: "#333" }}>No History Found</h3>
            <p style={{ color: "#666" }}>No distributions match your criteria.</p>
          </div>
        ) : (
          <>
            <div className="table-responsive">
              <table className="user-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Customer Name</th>
                    <th>Customer Email</th>
                    <th>Amount (TC)</th>
                    <th>Source</th>
                    <th>Reference</th>
                  </tr>
                </thead>
                <tbody>
                  {history.map((item) => (
                    <tr key={item.id}>
                      <td>{new Date(item.created_at).toLocaleDateString()}</td>
                      <td className="name-cell">
                        {item.customer_first_name} {item.customer_last_name}
                      </td>
                      <td>{item.customer_email}</td>
                      <td>{item.amount} TC</td>
                      <td>
                        {item.retail_first_name ? `${item.retail_first_name} ${item.retail_last_name} (Retail)` : 
                         item.supplier_first_name ? `${item.supplier_first_name} ${item.supplier_last_name} (Supplier)` : 
                         'System'}
                      </td>
                      <td>{item.reference_id || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <div className="pagination-container" style={{ marginTop: '20px' }}>
                <div className="pagination">
                  <button 
                    className="page-btn prev-next" 
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    ←
                  </button>
                  
                  <div className="page-numbers">
                    {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
                      let pageNum;
                      if (totalPages <= 5) {
                        pageNum = i + 1;
                      } else if (currentPage <= 3) {
                        pageNum = i + 1;
                      } else if (currentPage >= totalPages - 2) {
                        pageNum = totalPages - 4 + i;
                      } else {
                        pageNum = currentPage - 2 + i;
                      }
                      
                      return (
                        <button
                          key={i}
                          className={`page-btn ${currentPage === pageNum ? "active" : ""}`}
                          onClick={() => handlePageChange(pageNum)}
                        >
                          {pageNum}
                        </button>
                      );
                    })}
                  </div>
                  
                  <button 
                    className="page-btn prev-next" 
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    →
                  </button>
                </div>
                
                <div className="page-info">
                  Page {currentPage} of {totalPages}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default DistributionHistory;
